import type { Channel, ChannelFormData, ChannelNumber } from '../types';

export function channelToFormData(channel: Channel): ChannelFormData {
  console.log('[Transforms] Pre-Transform Channel:', channel);
  console.log('[Transforms] Channel numbers debug:', {
    channelId: channel.id,
    hasNumbers: Boolean(channel.numbers),
    numbersLength: channel.numbers?.length || 0,
    numbersSample: channel.numbers?.[0],
    numbersDebug: channel.numbers?.map((n: any) => ({
      id: n.id,
      type_id: n.type_id,
      number: n.number,
      is_sequence: n.is_sequence,
      is_default: (n as any).is_default,
      type: n.type,
      keys: Object.keys(n)
    }))
  });
  console.log('[Transforms] Channel categories debug:', {
    channelId: channel.id,
    hasCategories: Boolean(channel.categories),
    categories: channel.categories,
    categoryCount: channel.categories?.length || 0,
    categoryIds: channel.categories?.map(c => c.category_id) || []
  });
  
  // Handle plans with null checking and support for different formats
  const planIds = (channel.plans || []).map(p => {
    // Handle both formats: {plan: Plan} and direct Plan objects
    if ('plan' in p && p.plan && typeof p.plan === 'object' && 'id' in p.plan) {
      return p.plan.id;
    }
    // Direct Plan format - need to check if p has id property
    if ('id' in p) {
      return p.id; 
    }
    // Fallback if we can't get an ID
    return 0;
  }).filter(id => id > 0); // Remove any zero IDs from fallback
  
  // Extract category IDs and default category ID from the categories property
  let categoryIds: number[] = [];
  let defaultCategoryId: number | null = null;
  
  if (channel.categories && channel.categories.length > 0) {
    console.log('[Transforms] Using channel_categories junction table data');
    // Get all category IDs
    categoryIds = channel.categories.map(cc => cc.category_id);
    
    // Find the default category
    const defaultCategory = channel.categories.find(cc => cc.is_default);
    if (defaultCategory) {
      defaultCategoryId = defaultCategory.category_id;
    } else if (categoryIds.length > 0) {
      // If no default category is found, use the first one
      defaultCategoryId = categoryIds[0];
    }
  } else if (channel.category_id) {
    console.log('[Transforms] Fallback to legacy single category:', channel.category_id);
    // Fallback to legacy single category
    categoryIds = [channel.category_id];
    defaultCategoryId = channel.category_id;
  }
  
  // Extract tag IDs from tags property
  const tagIds = (channel.tags || []).map(t => t.tag_id || (t.tag?.id || 0)).filter(id => id > 0);

  // Log the local status
  console.log('[Transforms] Channel is_local:', {
    channelId: channel.id,
    is_local: channel.is_local,
    is_local_type: typeof channel.is_local
  });

  const formData = {
    name: channel.name,
    description: channel.description || '',
    category_id: defaultCategoryId, // Set to the default category for backward compatibility
    category_ids: categoryIds,
    default_category_id: defaultCategoryId,
    plan_ids: planIds,
    tag_ids: tagIds,
    price: channel.price ?? null,
    numbers: channel.numbers.map(n => ({
      typeId: n.type_id,
      number: n.number,
      is_sequence: n.is_sequence,
      is_default: n.is_default || false
    })),
    is_local: channel.is_local || false, // Include is_local status in form data
    is_duplicate: channel.is_duplicate || false // Include is_duplicate status in form data
  };
  console.log('[Transforms] Post-Transform FormData:', formData);
  return formData;
}

export function transformChannelNumbers(numbers: ChannelNumber[]): Array<{
  typeId: number;
  number: string;
  isSequence: boolean;
  is_default: boolean;
}> {
  return numbers.map(num => ({
    typeId: num.type_id,
    number: num.number || '',
    isSequence: num.is_sequence,
    is_default: num.is_default || false
  }));
} 